document.addEventListener('DOMContentLoaded', function () {
  const widget = document.getElementById('manga-request-widget');

  if (!widget) return;

  const tab = widget.querySelector('.manga-request-tab');
  const close = widget.querySelector('.manga-request-close');
  const drawer = widget.querySelector('.manga-request-drawer');

  function openDrawer() {
    widget.classList.add('is-open');
    tab.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    widget.classList.remove('is-open');
    tab.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  }

  tab.addEventListener('click', openDrawer);
  close.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  /*
   * Automatically open the drawer after a successful
   * Shopify contact form submission.
   */
  const successMessage = widget.querySelector('.manga-request-success');

  if (successMessage) {
  widget.classList.add('is-open', 'manga-request-no-animation');
  tab.setAttribute('aria-expanded', 'true');
  drawer.setAttribute('aria-hidden', 'false');
}
});